import { useEffect, useRef, useState } from "react";

import { Button, Text } from "@fragments";
import ConfigLoader from "../../components/ConfigLoader";
import Popper from "@components/Popper";

import './styles.css'

import api from '@helpers/api'

import { AddRounded, CopyAllRounded, DeleteRounded, LocalOfferRounded, MoreVertRounded, SettingsRounded } from "@mui/icons-material";

import { useCommunity } from "contexts/community";

import { useParams } from "react-router-dom";

import ConfigCouponModal from "@components/Modals/ConfigCouponModal";


export default function Coupons({ info }) {
    const [loading, setLoading] = useState(true)

    let { slug } = useParams();

    const [coupons, setCoupons] = useState([])

    const { loading: communityLoading, community, loadCommunities } = useCommunity();

    const REF_config = useRef()
    const REF_configCouponModal = useRef()

    const popperRef = useRef()


    useEffect(() => {
        if (!communityLoading) handleLoad()
    }, [communityLoading])

    async function handleLoad() {
        setLoading(true)

        try {
            const currentCommunity = community.getBySlug(slug);
            if (currentCommunity?.id) {
                const { data } = await api.get(`community/${currentCommunity.id}/coupon`)
                setCoupons([...data])
            }
        } catch (e) {
            console.log(e)
        }

        setLoading(false)
    }

    function handleConfigureCoupon(id) {
        const currentCommunity = community.getBySlug(slug);
        const plan = id ? coupons?.filter(p => p.id === id)[0] : {
            community: currentCommunity.id
        }

        REF_configCouponModal.current.open(plan, async function (result) {
            console.log(result)
            handleLoad()
        })
    }

    function handleDeleteCoupon(id) {
        window.openConfirm({
            title: "Deletar cupom",
            headline: "Atenção!",
            subtitle: "Você realmente deseja apagar permanentemente este cupom?",
            buttons: [
                {
                    text: "Apagar permanentemente",
                    onClick: handleExecuteDelete,
                    variant: "contained",
                    className: "",
                    color: "error",
                },
                {
                    text: "Manter cupom",
                    variant: "text",
                },
            ],
        });

        async function handleExecuteDelete() {
            try {
                const { data } = await api.delete('coupon?id=' + id)
                if (data.result) {
                    window.setSnackbar('Cupom deletado com sucesso')
                    await handleLoad()
                }
            } catch (e) {
                console.log(e)
            }
        }
    }

    function handleOpenPlanOptions(event, planId) {
        const options = [
            {
                id: 'configure',
                label: 'Configurar',
                icon: <SettingsRounded fontSize="small" />,
                onClick: async () => {
                    handleConfigureCoupon(planId);
                    popperRef.current.close();
                }
            },
            {
                id: 'delete',
                label: 'Excluir cupom',
                icon: <DeleteRounded fontSize="small" />,
                variant: 'danger',
                onClick: async () => {
                    handleDeleteCoupon(planId);
                    popperRef.current.close();
                }
            }
        ];

        popperRef.current.open(options, 'bottom', event.currentTarget);
    }

    function handleCopy(code) {
        const link = `https://pay.ginastee.com/${community.getBySlug(slug).checkout}?coupon=${code}`

        console.log(link)
        navigator.clipboard.writeText(link).then(() => {
            window.setSnackbar("Link copiado");
        }).catch(err => {
            console.error('Erro ao copiar:', err);
            window.setSnackbar("Erro ao copiar o link");
        });
    }


    function CouponRow({ id, code, percent_off }) {
        return (
            <div className="plan-config-box mb-1">
                <div className="plan-config-row py-1 pr-1 pl-2">
                    <h5 style={{ flex: 1 }} className="bold">{code} • {percent_off}%</h5>
                    <span className="plan-row-btn"
                        onClick={() => handleCopy(code)}
                    >
                        <small>Link do checkout</small>
                        <CopyAllRounded fontSize="small" />
                    </span>
                    <span
                        className="plan-row-btn"
                        onClick={() => handleConfigureCoupon(id)}>
                        <SettingsRounded fontSize="small" />
                    </span>
                    <span
                        className="plan-row-btn"
                        onClick={(event) => handleOpenPlanOptions(event, id)}
                    >
                        <MoreVertRounded fontSize="small" />
                    </span>
                </div>
            </div>
        )
    }

    function CreateCouponButton() {
        return (
            <Button
                onClick={() => handleConfigureCoupon()}
                endIcon={<AddRounded />}
                text="Criar cupom"
            />
        )
    }


    return (
        <div className="config-page config-general-community" key={loading}>
            {(loading || communityLoading) ? <ConfigLoader /> : (
                <div className="mt-4" key={Math.random()}>
                    <Text.h3
                        value="Cupons de desconto"
                        className="mb-2"
                        left={<LocalOfferRounded />}
                        right={<CreateCouponButton />}
                        grow
                    />

                    {coupons?.map((plan, key) => (
                        <CouponRow
                            key={key}
                            {...plan}
                        />
                    ))}
                </div>
            )}

            <Popper controlRef={popperRef} />

            <ConfigCouponModal modalRef={REF_configCouponModal} />
        </div >
    )
}